t = require('views/internal/teacup-with-helpers')('search_suggetion_board')

module.exports = ->
  t.a '.search-suggestion.search-suggestion-board.js-select-suggestion', { href: '#', 'data-suggestionphrase': t.mustacheVar('phrase') }, ->
    t.span '.search-suggestion-board-image'
    t.span '.search-suggestion-dec', ->
      t.format 'cards-on-the-board-name', { name: t.mustacheVar('name') }, { raw: true }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/search_suggetion_board.coffee